export const percentageOfNumber = (
  number: number,
  percentage: number,
): number => {
  return number * (percentage / 100)
}
